import logo from "../assets/img/ps-logo.svg";
import btnLoader from "../assets/img/BtnLoader.gif";
import error from "../assets/img/Error.svg";
import close from "../assets/img/Close.svg";
import success from "../assets/img/Success.svg";
import loader from "../assets/img/Spinner.gif";
import acceptIconImage from "../assets/img/Accept.svg";
import rejectIconImage from "../assets/img/Reject.svg";
import deactivateIconImage from "../assets/img/Deactivate.svg";
import logout from "../assets/img/Logout.svg";
import logoutWhite from "../assets/img/LogoutWhite.svg";
import userImg from "../assets/img/userImg.png";
import plugActive from "../assets/img/plugActive.svg";
import plug from "../assets/img/plug.svg";
import contractActive from "../assets/img/contractActive.svg";
import contract from "../assets/img/contract.svg";
import activate from "../assets/img/tick (1).svg";
// import dashboard from '../assets/img/dasboardImg.jpg'
import homeConnection from "../assets/img/homeConnections.png";
import homeTask from "../assets/img/homeTasks.png";
import homeUser from "../assets/img/homeUsers.png";
import homeBgImg from "../assets/img/Union.png";
import homeicon from "../assets/img/home_white.svg";
import usericon from "../assets/img/User_white.svg";
import allIcon from "../assets/img/All.png";
import successIcon from "../assets/img/Success.png";
import warningIcon from "../assets/img/Warning.png";
import ignoreIcon from "../assets/img/Ignore.png";
import failedIcon from "../assets/img/Failed.png";
import taskLog from "../assets/img/TaskLog.png";
import mapping from "../assets/img/mapping.png";
import Capa_1 from "../assets/img/Capa_1.png";
import alltriggers from "../assets/img/alltriggers.svg";
import failedtriggers from "../assets/img/failedtriggers.svg";
import successtriggers from "../assets/img/successtriggers.svg";
import noSelectedDatasource from "../assets/img/choose source.svg";
import noConnectionSelected from "../assets/img/noconnectionselected.jpg";
import noLogsSelected from "../assets/img/logs.png";
import AddTaskPopupImg from "../assets/img/source.png";
import HomeIcon from "../assets/img/homeicon.svg"
import ignored from "../assets/img/ignore.svg";
import warning from "../assets/img/Warning.svg";
import bgLogin from "../assets/img/bg-login.png";
import fileUploadIcon from "../assets/img/image-placeholder.svg";
import infoIcon from "../assets/img/info.svg";
import addIcon from "../assets/img/add-icon.svg";
import existingSelection from "../assets/img/select-existing.svg";
import entityDashboardImg from "../assets/img/entity-dashboard.svg";
import noRecordImg from "../assets/img/no-record.png";
import grDetailIcon from "../assets/entity/gr-detail icon.svg";
import grBackIcon from "../assets/entity/back.svg";
import editPenIcon from "../assets/img/edit-pen.svg";
import error404 from "../assets/img/error404.svg";
import error500 from "../assets/img/error500.svg";
import totalusers from "../assets/img/totalusers.svg";
import rolesettings from "../assets/img/rolesettings.svg";
import users from "../assets/img/users.svg";
import logoutNew from "../assets/img/logoutNew.svg";
import defaultImage from "../assets/img/placeholder.png";
import dataAnomaly from "../assets/img/Data Anomaly.svg";
import duplicateRecords from "../assets/img/Duplicate Records.svg";
import incompleteRecords from "../assets/img/Incomplete Records.svg";
import dataQuality from "../assets/img/Data Quality.svg";
import sap from "../assets/img/sap.png";
import salesforce from "../assets/img/salesforce.jpg";
import erp from "../assets/img/ERP.png";
import azure from "../assets/img/Azure.png";
import mySQL from "../assets/img/MySQL.png";
import greenCheck from "../assets/img/Green Check.png";
import redCross from "../assets/img/Red Cross.png";
import syncing from "../assets/img/Syncing.png";
import userIcon from "../assets/img/user.png";
import editIcon from "../assets/img/edit-pen.svg";
import addIconEntity from "../assets/entity/addIconEntity.svg";
import addnewBtnImage from "../assets/entity/addnewBtnImage.svg";
import parentDropdownIcon from "../assets/entity/parentDropdownIcon.svg";
import skuDropdownIcon from "../assets/entity/skuDropdownIcon.svg";
import skuFileUploadIcon from "../assets/entity/skuFileUploadIcon.svg";
import topnavUserIcon from "../assets/topnav-icons/user-image.svg";
import viewIcon from "../assets/img/viewIcon.png";
import separationImg from "../assets/img/separationImg.svg";
import rightArrow from "../assets/img/rightArrow.svg";
import workflowDeleteIcon from "../assets/workflow-icons/delete-icon.svg";
import defaultUserIcon from "../assets/workflow-icons/default-user.svg";
import selectedUserIcon from "../assets/workflow-icons/check-user.svg";
import selectTransformationIcon from "../assets/pipeline/selectTransformation.svg";
import pipelineconnectors from "../assets/pipeline/pipelineconnectors.svg";
import triggerpipeline from "../assets/pipeline/triggerpipeline.png";
import schedulePipelineGroup from "../assets/pipeline/schedulePipelineGroup.svg";
import greenediticon from "../assets/img/greenEditIcon.png";
import plusIcon from "../assets/img/plusIcon.svg";
import deleteIcon from "../assets/img/deleteIcon.svg";
import equalsignicon from "../assets/img/equalsignIcon.svg";
import incrementalIcon from "../assets/img/incrementalIcon.svg";
import verticalSeparator from "../assets/img/verticalSeparator.svg";
import joinTablesIcon from "../assets/img/jointablesIcon.svg";
import noColumnsImg from "../assets/img/noColumnsImage.png";
import warningImage from "../assets/entity/warningIcon.svg";
import deleteIconBg from "../assets/img/deleteIconWithBg.png";
import blackAddIcon from "../assets/img/blackAddIcon.svg";
import copyIcon from "../assets/img/copyIcon.svg";
import sourceTable from "../assets/img/sourcetable.svg";
import pipelineAddIcon from "../assets/img/pipelineAddIcon.svg";
import pipelineJoin from "../assets/img/pipelinejoin.svg";
import pipelineUnion from "../assets/img/pipelineunion.svg";
import pipelineLookup from "../assets/img/pipelinelookup.svg";
import pipelineDerivedColumn from "../assets/img/pipelinederivedcolumn.svg";
import pipelineAggregate from "../assets/img/pipelineaggregate.svg";
import pipelineFilter from "../assets/img/pipelinefilter.svg";
import pipelineSort from "../assets/img/pipelinesort.svg";
import pipelineAlterRow from "../assets/img/pipelinealterrow.svg";
import PipelineSourceImage from "../assets/pipeline/pipelineSourceImage.svg";
import PipelineSourceImageUnselected from "../assets/pipeline/PipelineSourceImageUnselected.svg";
import standerdisationDelete from "../assets/pipeline/standerdisationDelete.svg";
import pipelineConnectionBar from "../assets/pipeline/pipelineConnectionBar.svg";
import pipelineWarningIcon from "../assets/pipeline/pipelineWarningIcon.svg";
import TitleIcon from "../assets/img/title-icon.svg";
import NameIcon from "../assets/img/name-icon.svg";
import PhoneIcon from "../assets/img/phn-icon.svg";
import AddressIcon from "../assets/img/location-icon.svg";
import DescIcon from "../assets/img/description-icon.svg";
import SubTitileIcon from "../assets/img/subtitle-icon.svg";
import IdIcon from "../assets/img/id-icon.svg";
import PostalcodeIcon from "../assets/img/postalcode-icon.svg";
import NumQuanIcon from "../assets/img/num-quan-icon.svg";
import A1Icon from "../assets/img/A1-icon.svg";
import EmailIcon from "../assets/img/@-icon.svg";
import AddColIcon from "../assets/img/addcol-icon.svg";
import pipelineConnectors from "../assets/pipeline/i-connectors.svg";
import pipelineTriggerSuccess from "../assets/pipeline/pipelinetriggersuccess.svg";
import pipelineTriggerFailed from "../assets/pipeline/pipelinetriggerfailed.svg";
import pipelineViewEye from "../assets/pipeline/pipelineViewEye.svg";
import pipelineEditPencil from "../assets/pipeline/pipelineEditPencil.svg";
import pipelineactionrightarrow from "../assets/pipeline/pipelineactionrightarrow.svg";
import pipelineTriggerIcon from "../assets/pipeline/pipelineTriggerIcon.svg";
import pipelineTriggerSuccessIcon from "../assets/pipeline/pipelineTriggerSuccessIcon.svg";
import pipelineTriggerFailedIcon from "../assets/pipeline/pipelineTriggerFailedIcon.svg";
import pipelineTriggerInProgressIcon from "../assets/pipeline/pipelineTriggerInProgressIcon.svg";
import pipelineExpand from "../assets/pipeline/pipelineExpand.svg";
import pipelineCondense from "../assets/pipeline/pipelinecondense.svg";
import pipelineViewAllIcon from "../assets/pipeline/pipelineViewAllIcon.svg";
import masterShowonCardImg from "../assets/masterImages/masterShowonCardImg.svg";
import blackDownIcon from "../assets/img/blackDownIcon.png";
import plusIconPng from "../assets/img/plusIcon.png";
import overviewIcon from "../assets/img/overviewIcon.png";
import controlTowerIcon from "../assets/img/controlTowerIcon.png";
import entityIcon from "../assets/img/entityIcon.png";
import integrationIcon from "../assets/img/integrationIcon.png";
import reportIcon from "../assets/img/reportIcon.png";
import settingIcon from "../assets/img/setingIcon.png";
import taxonomyIcon from "../assets/img/taxonomyIcon.png";
import workflowIcon from "../assets/img/workflowIcon.png";
import masterIcon from "../assets/img/masterIcon.png";
import leftArrowIcon from "../assets/img/leftArrowIcon.png";
import dataNexusLogo from "../assets/img/dataNexusLogo.png";
import wormholeGreenLogo from "../assets/img/wormholeGreenLogo.png";
import mdmBlueLogo from "../assets/img/mdmBlueLogo.png";
import sideNavProjectIcon from "../assets/sidenav_icons/projects unselected.svg";
import sideNavProjectIconSelected from "../assets/sidenav_icons/selectedProjectIcon.svg";
import arrowDown from "../assets/img/arrow-down.svg";
import MDM360 from "../assets/img/MDM360.png";
import Wormhole from "../assets/icons/Wormhole.png";
import DataNexus from "../assets/img/DATA NEXUS.png";
import reportAssignUserIcon from "../assets/report/reportAssignUserIcon.svg";
import infoSuccess from "../assets/report/infoSuccess.svg";
import infoError from "../assets/report/infoError.svg";
import noUserImg from "../assets/report/noUserImg.svg";
import reportsfk from "../assets/report/reportsfk.svg";
import reportAlias from "../assets/report/reportAlias.svg";
import reportExport from "../assets/report/reportExport.svg";
import filterImg from "../assets/report/filterImg.svg";
import reportFilterCross from "../assets/report/reportFilterCross.svg";
import Arrow from "../assets/img/workapacearrow.png";
import MDM360TEXT from "../assets/img/MDM-360Text.png";
import WormholeText from "../assets/img/WormholeText.png";
import DataNexusText from "../assets/img/DataNexusText.png";
import calenderWithDate from "../assets/img/calenderDate.png";
import pipelineIcon from "../assets/img/pipelineIcon.png";
import reportExportIcon from "../assets/report/reportExportIcon.svg";
import polestarLogo from "../assets/img/Polestar_Logo_Original.svg";
import microsoft from "../assets/img/microsoft.svg";
import loginImg from "../assets/img/loginImg.svg";
import oneplatformlogo from "../assets/img/oneplatform-logo.svg";
import databasearrowright from "../assets/img/database-arrow-right.png";
import masknotepadicon from "../assets/img/mask-notepad-icon.png";
import maskaiicon from "../assets/img/mask-ai-icon.png";
import downloadicon from "../assets/img/download-icon.png";
import fileicon from "../assets/img/Fileicon.png";
import downloadblueicon from "../assets/img/download-blue-icon.png";
import unstructuredtostructure from "../assets/img/unstructuredtostructure.png";
import Biportaltext from "../assets/img/Biportaltext.png";
import unstructuredToStructuredReducer from "../assets/img/UTS.png";
import BiPortal from "../assets/img/BiPortal.png";
import PAI from "../assets/img/P.AI.png";
import PAITEXT from "../assets/img/P.AI text.png";
import indexor from "../assets/img/INDEXOR.png";
import indexortext from "../assets/img/INDEXORTEXT.png";
import dbconnect from "../assets/img/dbconnect.png";
import editSVGIcon from "../assets/img/editSVGIcon.svg";
import viewSVGIcon from "../assets/img/viewSVGIcon.svg";
import deleteSVGIcon from "../assets/img/deleteSVGIcon.svg";
import dollarIcon from "../assets/img/dollarIcon.png";
import saleGraphIcon from "../assets/img/salesGraphIcon.png";
import growthGreenGraph from "../assets/img/growthGreenGraph.png";
import lossRedGraph from "../assets/img/lossRedGraph.png";
import upArrow from "../assets/img/upArrow.png";
import downArrow from "../assets/img/downArray.png";
import redAlert from "../assets/img/redAlert.png";
import blackYellowIcon from "../assets/img/blackYellowIcon.png";
import pinIcon from "../assets/img/pinIcon.png";
import closeIcon from "../assets/img/Close.svg";
import backYellowIcon from "../assets/img/backIcon.png";
import mergeIcon from "../assets/img/mergeIcon.png";
import clipboardIcon from "../assets/img/clipboardIcon.png";
import inventoryBoxIcon from "../assets/img/inventoryBoxIcon.png";
import calendarIcon from "../assets/img/calendarIcon.png";
import quantityIcon from "../assets/img/quantityIcon.png";
import clockIcon from "../assets/img/clockIcon.png";
import bellBlackIcon from "../assets/img/bellBlackIcon.png";

import deduplicationDashobardSVG from "../assets/img/deduplicationDashboardSVG (2).svg";
import starMark from "../assets/img/starMark.png";
import timer from "../assets/img/timer.png";
import accuracy from "../assets/img/accuracy.png";
import hit from "../assets/img/hit.png";
import highlightbulb from "../assets/img/highlightbulb.png";
import agentBG from "../assets/img/agent_bg.jpg";

import svgTriggerIcon from "../assets/img/svgTriggerIcon.svg";
import PipelineRun from "../assets/img/PipelineRun.svg";
import maki_arrow from "../assets/img/maki_arrow.png";
import edit_Vector from "../assets/img/edit_Vector.png";
import leftarrow from "../assets/img/leftarrow.png";
import mdmlogo from "../assets/img/mdmlogo.svg";
// import leftarrow from "../assets/img/leftarrow.png";
// import addUnionSource from "../assets/img/addUnionSource.svg";
// import deleteUnionSource from "../assets/img/deleteUnionSource.svg";
import addUnionSource from "../assets/img/addUnionSource.svg";
import deleteUnionSource from "../assets/img/deleteUnionSource.svg";
// import leftarrow from "../assets/img/leftarrow.png";
// import mdmlogo from "../assets/img/mdmlogo.svg";
import editBlueIcon from "../assets/img/editBlueIcon.png";
import deleteOrangeIcon from "../assets/img/deleteOrangeIcon.png";
import calendarBlueIcon from "../assets/img/calendarBlueIcon.png";
import settingRedIcon from "../assets/img/settingRedIcon.png";
import DataLineage from "../assets/img/Datalineage.svg";
import connectionicon from "../assets/img/Connectionicon.svg";
import Ingestionpipelineicon from "../assets/img/Ingestionpipelineicon.svg";
import datalakeicon from "../assets/img/datalakeicon.svg";
import transformationicon from "../assets/img/transformationicon.svg";
import DataprofilerIcon from "../assets/img/DataprofilerIcon.svg";
import ProcessSchedulerIcon from "../assets/img/ProcessSchedulerIcon.svg";
import DataModelIcon from "../assets/img/DataModelIcon.svg";
import yellowAddButtonBar from "../assets/img/yelloAddBar.png"
import plusSquareFilledBlack from "../assets/img/PlusSquareFilledBlack.svg"
import paiICON from "../assets/img/paiIcon.png";
import chatBot from "../assets/img/chatbot.png";
import sendIcon from "../assets/img/sendIcon.png";
import PAIbot from "../assets/img/PAIBOT.png";
import taskMasterAIText from "../assets/img/TaskMasterAIText.png";
import locationIcon from "../assets/img/locationIcon.png";
import clipOrderIcon from "../assets/img/clipOrderIcon.png";
import develpment from "../assets/img/Development.svg"
import production from "../assets/img/Production.svg"
import uat from "../assets/img/UAT.svg"
import num_to_string from "../assets/pipeline/num_to_string.svg";
import string_to_date from "../assets/pipeline/string_to_calender.svg";
import concatenation from "../assets/pipeline/concatenation.svg";
import datatype_validation from "../assets/pipeline/datatype_validation.svg";
import download_icon from "../assets/icons/download-icon.png";
import fixon from "../assets/icons/ficon.png";
import derivedIcon from "../assets/icons/derived-icon.png";
import bi_home from "../assets/img/bi-home.svg";
import bi_home_selected from "../assets/img/bi-home-selected.svg";
import bi_chatbot from "../assets/img/bi-chatbot.svg";
import bi_portal_insights from "../assets/img/bi-portal-insights.svg";
import bi_portal_analytics_options from "../assets/img/biportalAllAnalyticsOption.png";
import bi_portal_agents from "../assets/img/biportalAgents.png";
import biportaldashboard from "../assets/img/biportaldashboard.png";
import biportalProcess from "../assets/img/biportalProcess.png";
import bi_portal_dashboards from "../assets/img/bi-portal-dashboards.svg";
import search_icon from "../assets/img/searchIcon.png";
import sort_icon from "../assets/img/sortIcon.png";
import cancel_icon from "../assets/img/biPortalCancel.png";
import dragNdrop_icon from "../assets/img/dragndropVector.png";
import addVector_icon from "../assets/img/addVector.svg";
import userPersona from "../assets/img/Userpersona.png";
import darkdownarray from "../assets/img/downArrowdark.svg";
import collapsesideNav from "../assets/img/CollapseSidenav.svg";
import onepLogo from "../assets/img/1PLogo.svg";
import searchIcon from "../assets/img/searchIcon.svg";
import profiletemplate from "../assets/img/profileTemplate.svg";
import password from "../assets/img/password.svg";
import logouttemplate from "../assets/img/logouttemplate.svg"
import filters from "../assets/img/filters.png";
import FilterFxEditIcon from "../assets/img/FilterFxEditIcon.svg";
import fxicon from "../assets/img/fxicon.svg";
import triggerIcon from "../assets/pipeline/triggerpipeline.png";
import ExclamationCircleBiportal from "../assets/img/ExclamationCircleBiportal.svg";
import BiportalConfiguration from "../assets/img/BiportalConfigure.svg";
import BiportalDeactivate from "../assets/img/BiportalDeactivate.svg";
import activeIcon from "../assets/img/active_circle.svg";
import completedIcon from "../assets/img/completed_icon.svg";
import backArrowIcon from "../assets/img/Arrow-back.svg";
import AddButton from "../assets/img/AddButton.svg";
import AgentHoodCreateAgent from "../assets/img/AgentHoodCreateAgent.svg";
import AgentHoodBack from "../assets/img/AgentHoodBack.svg";
import AgentHoodMaskgroup from "../assets/img/AgentHoodMaskgroup.svg";
import agentHoodChatBot from "../assets/img/agentHoodChatBot.svg";
import AgentHoodSampleAgents from "../assets/img/AgentHoodSampleAgents.svg";
import AgenthoodCopytext from "../assets/img/AgenthoodCopytext.svg";
import AgentHoodFileUpload from "../assets/img/AgentHoodFileUpload.svg";
import AgentHoodMessageSend from "../assets/img/AgentHoodMessageSend.svg";
import AgentHoodSuccessIcon from "../assets/img/AgentHoodSuccessIcon.svg";
import AgentHoodFailedIconExclamation from "../assets/img/AgentHoodFailedIconExclamation.svg";
import Agentichood from "../assets/img/Agentichood.svg";
import radioButtonChecked from "../assets/img/radio_button_checked.svg";
import ChatbotIcon from "../assets/img/chatIcon.svg";
import removeIcon from "../assets/img/removeCross.svg";
export const ImageUrl = {
  transformationicon: transformationicon,
  DataprofilerIcon: DataprofilerIcon,
  ProcessSchedulerIcon: ProcessSchedulerIcon,
  DataModelIcon: DataModelIcon,
  datalakeicon: datalakeicon,
  Ingestionpipelineicon: Ingestionpipelineicon,
  connectionicon: connectionicon,
  PipelineRun: PipelineRun,
  deduplicationDashobardSVG: deduplicationDashobardSVG,
  svgTriggerIcon: svgTriggerIcon,
  fxicon:fxicon,
  mdmlogo: mdmlogo,
  PAIbot: PAIbot,
  editSVGIcon: editSVGIcon,
  viewSVGIcon: viewSVGIcon,
  deleteSVGIcon: deleteSVGIcon,
  dataNexusLogo: dataNexusLogo,
  plusIconPng: plusIconPng,
  unstructuredtostructure: unstructuredtostructure,
  wormholeGreenLogo: wormholeGreenLogo,
  mdmBlueLogo: mdmBlueLogo,
  MDM360: MDM360,
  Wormhole: Wormhole,
  DataNexus: DataNexus,
  indexor: indexor,
  indexortext: indexortext,
  PAI: PAI,
  PAITEXT: PAITEXT,
  Arrow: Arrow,
  Biportaltext: Biportaltext,
  MDM360TEXT: MDM360TEXT,
  WormholeText: WormholeText,
  DataNexusText: DataNexusText,
  DataLineage: DataLineage,
  UTS: unstructuredToStructuredReducer,
  BiPortal: BiPortal,
  overviewIcon: overviewIcon,
  arrowDown: arrowDown,
  workflowIcon: workflowIcon,
  leftArrowIcon: leftArrowIcon,
  controlTowerIcon: controlTowerIcon,
  masterIcon: masterIcon,
  taxonomyIcon: taxonomyIcon,
  settingIcon: settingIcon,
  reportIcon: reportIcon,
  integrationIcon: integrationIcon,
  entityIcon: entityIcon,
  blackDownIcon: blackDownIcon,
  Logo: logo,
  BtnLoader: btnLoader,
  Error: error,
  Close: close,
  Success: success,
  Loader: loader,
  AcceptIconImage: acceptIconImage,
  RejectIconImage: rejectIconImage,
  DeactivateIconImage: deactivateIconImage,
  Activate: activate,
  Logout: logout,
  LogoutWhite: logoutWhite,
  UserImg: userImg,
  PlugActive: plugActive,
  Plug: plug,
  ContractActive: contractActive,
  Contract: contract,
  // Dashboard: dashboard,
  HomeConnection: homeConnection,
  HomeIcon: HomeIcon,
  HomeTask: homeTask,
  HomeUser: homeUser,
  HomeBgImg: homeBgImg,
  Homelogo: homeicon,
  Userlogo: usericon,
  AllLogo: allIcon,
  SuccessLogo: successIcon,
  WarningLogo: warningIcon,
  IgnoreLogo: ignoreIcon,
  FailedLogo: failedIcon,
  TaskLogo: taskLog,
  Mapping: mapping,
  Capa_1: Capa_1,
  alltriggers: alltriggers,
  failedtriggers: failedtriggers,
  successtriggers: successtriggers,
  noSelectedDatasource: noSelectedDatasource,
  noConnectionSelected: noConnectionSelected,
  noLogsSelected: noLogsSelected,
  AddTaskPopupImg: AddTaskPopupImg,
  IgnoredImg: ignored,
  warningImg: warning,
  bgLogin: bgLogin,
  FileUploadIcon: fileUploadIcon,
  InfoIcon: infoIcon,
  AddIcon: addIcon,
  ExistingSelection: existingSelection,
  EntityDashboardImg: entityDashboardImg,
  NoRecordImg: noRecordImg,
  GRBackIcon: grBackIcon,
  GRDetailIcon: grDetailIcon,
  EditPenIcon: editPenIcon,
  Error404: error404,
  Error500: error500,
  TotalUsers: totalusers,
  RoleSettings: rolesettings,
  Users: users,
  LogoutNew: logoutNew,
  DefaultEntityCardImage: defaultImage,
  DataAnomaly: dataAnomaly,
  DuplicateRecords: duplicateRecords,
  IncompleteRecords: incompleteRecords,
  DataQuality: dataQuality,
  SAP: sap,
  Salesforce: salesforce,
  ERP: erp,
  Azure: azure,
  MySQL: mySQL,
  GreenCheck: greenCheck,
  RedCross: redCross,
  Syncing: syncing,
  UserIcon: userIcon,
  EditIcon: editIcon,
  AddIconEntity: addIconEntity,
  AddnewBtnImage: addnewBtnImage,
  ParentDropdownIcon: parentDropdownIcon,
  SkuDropdownIcon: skuDropdownIcon,
  SkuFileUploadIcon: skuFileUploadIcon,
  TopnavUserIcon: topnavUserIcon,
  ViewIcon: viewIcon,
  SeparationImg: separationImg,
  RightArrow: rightArrow,
  WorkflowDeleteIcon: workflowDeleteIcon,
  DefaultUserIcon: defaultUserIcon,
  SelectTransformationIcon: selectTransformationIcon,
  Pipelineconnectors: pipelineconnectors,
  TriggerPipeline: triggerpipeline,
  GreenEditIcon: greenediticon,
  PlusIcon: plusIcon,
  DeleteIcon: deleteIcon,
  EqualSignIcon: equalsignicon,
  IncrementalIcon: incrementalIcon,
  VerticalSeparator: verticalSeparator,
  JoinTablesIcon: joinTablesIcon,
  NoColumnsImg: noColumnsImg,
  WarningImage: warningImage,
  DeleteIconWithBg: deleteIconBg,
  BlackAddIcon: blackAddIcon,
  CopyIcon: copyIcon,
  SourceTable: sourceTable,
  PipelineAddIcon: pipelineAddIcon,
  PipelineJoin: pipelineJoin,
  PipelineUnion: pipelineUnion,
  PipelineLookup: pipelineLookup,
  PipelineDerivedColumn: pipelineDerivedColumn,
  PipelineAggregate: pipelineAggregate,
  PipelineFilter: pipelineFilter,
  PipelineSort: pipelineSort,
  PipelineAlterRow: pipelineAlterRow,
  SchedulePipelineGroup: schedulePipelineGroup,
  PipelineSourceImage: PipelineSourceImage,
  PipelineSourceImageUnselected: PipelineSourceImageUnselected,
  StanderdisationDelete: standerdisationDelete,
  pipelineConnectionBar: pipelineConnectionBar,
  PipelineWarningIcon: pipelineWarningIcon,
  TitleIcon: TitleIcon,
  NameIcon: NameIcon,
  PhoneIcon: PhoneIcon,
  AddressIcon: AddressIcon,
  DescIcon: DescIcon,
  SubTitileIcon: SubTitileIcon,
  IdIcon: IdIcon,
  PostalcodeIcon: PostalcodeIcon,
  NumQuanIcon: NumQuanIcon,
  A1Icon: A1Icon,
  EmailIcon: EmailIcon,
  AddColIcon: AddColIcon,
  PipelineConnectors: pipelineConnectors,
  pipelineTriggerSuccess: pipelineTriggerSuccess,
  pipelineTriggerFailed: pipelineTriggerFailed,
  pipelineTriggerInProgressIcon: pipelineTriggerInProgressIcon,
  PipelineViewEye: pipelineViewEye,
  PipelineEditPencil: pipelineEditPencil,
  Pipelineactionrightarrow: pipelineactionrightarrow,
  PipelineTriggerIcon: pipelineTriggerIcon,
  PipelineTriggerSuccessIcon: pipelineTriggerSuccessIcon,
  PipelineTriggerFailedIcon: pipelineTriggerFailedIcon,
  PipelineCondense: pipelineCondense,
  PipelineExpand: pipelineExpand,
  ReportAssignUserIcon: reportAssignUserIcon,
  InfoSuccess: infoSuccess,
  InfoError: infoError,
  NoUserImg: noUserImg,
  Reportsfk: reportsfk,
  ReportAlias: reportAlias,
  ReportExport: reportExport,
  FilterImg: filterImg,
  ReportFilterCross: reportFilterCross,
  PipelineViewAllIcon: pipelineViewAllIcon,
  MasterShowonCardImg: masterShowonCardImg,
  SideNavProjectIcon: sideNavProjectIcon,
  SideNavProjectIconSelected: sideNavProjectIconSelected,
  CalenderWithDate: calenderWithDate,
  PipelineIcon: pipelineIcon,
  ReportExportIcon: reportExportIcon,
  PolestarLogo: polestarLogo,
  Microsoft: microsoft,
  LoginImg: loginImg,
  Oneplatformlogo: oneplatformlogo,
  DatabaseArrowRight: databasearrowright,
  MaskNotepadIcon: masknotepadicon,
  MaskAiIcon: maskaiicon,
  DownloadIcon: downloadicon,
  FileIcon: fileicon,
  DownloadBlueIcon: downloadblueicon,
  dbconnect: dbconnect,
  DollarIcon: dollarIcon,
  SaleGraphIcon: saleGraphIcon,
  GrowthGreenGraph: growthGreenGraph,
  LossRedGraph: lossRedGraph,
  UpArrow: upArrow,
  DownArrow: downArrow,
  RedAlert: redAlert,
  BlackYellowIcon: blackYellowIcon,
  PinIcon: pinIcon,
  CloseIcon: closeIcon,
  BackYellowIcon: backYellowIcon,
  MergeIcon: mergeIcon,
  ClipboardIcon: clipboardIcon,
  InventoryBoxIcon: inventoryBoxIcon,
  CalendarIcon: calendarIcon,
  QuantityIcon: quantityIcon,
  ClockIcon: clockIcon,
  BellBlackIcon: bellBlackIcon,
  maki_arrow: maki_arrow,
  edit_Vector: edit_Vector,
  leftarrow: leftarrow,
  AddUnionSource: addUnionSource,
  DeleteUnionSource: deleteUnionSource,
  Hit: hit,
  Accuracy: accuracy,
  StarMark: starMark,
  Timer: timer,
  Highlight: highlightbulb,
  YellowAddButtonBar: yellowAddButtonBar,
  PlussquarefilledBlack: plusSquareFilledBlack,
  EditBlueIcon: editBlueIcon,
  DeleteOrangeIcon: deleteOrangeIcon,
  CalendarBlueIcon: calendarBlueIcon,
  SettingRedIcon: settingRedIcon,
  paiICON: paiICON,
  AgentBG: agentBG,
  ChatBot: chatBot,
  SendIcon: sendIcon,
  TaskMasterAIText: taskMasterAIText,
  LocationIcon: locationIcon,
  ClipOrderIcon: clipOrderIcon,
  Develpment: develpment,
  Production: production,
  Uat: uat,
  NumToString: num_to_string,
  StringToDate: string_to_date,
  Concatenation: concatenation,
  DatatypeValidation: datatype_validation,
  downloadIcon: download_icon,
  fixon: fixon,
  derivedIcon: derivedIcon,
  BiHome: bi_home,
  BiHomeSelected: bi_home_selected,
  BiChatbot: bi_chatbot,
  BiPortalInsights: bi_portal_insights,
  BiPortalAnalyticsOptions: bi_portal_analytics_options,
  BiPortalDashboards: bi_portal_dashboards,
  BiPortalAgents: bi_portal_agents,
  BiPortalDashboard: biportaldashboard,
  BiPortalProcess: biportalProcess,
  BiPortalSearch: search_icon,
  BiPortalSort: sort_icon,
  BiPortalCancel: cancel_icon,
  BiPortalDragNdrop: dragNdrop_icon,
  BiPortalAddVector: addVector_icon,
  UserPersona: userPersona,
  DarkDownArray: darkdownarray,
  CollapseSideNav: collapsesideNav,
  OnepLogo: onepLogo,
  SearchIcon: searchIcon,
  profileTemplate: profiletemplate,
  Password: password,
  Logouttemplate: logouttemplate,
  Filters: filters,
  FilterFxEditIcon: FilterFxEditIcon,
  Trigger: triggerIcon,
  ExclamationCircleBiportal: ExclamationCircleBiportal,
  BiportalConfiguration: BiportalConfiguration,
  BiportalDeactivate: BiportalDeactivate,
  ActiveIcon: activeIcon,
  CompletedIcon: completedIcon,
  BackArrowIcon: backArrowIcon,
  AddButton: AddButton,
  AgentHoodCreateAgent: AgentHoodCreateAgent,
  AgentHoodBack: AgentHoodBack,
  AgentHoodMaskgroup: AgentHoodMaskgroup,
  AgentHoodChatBot: agentHoodChatBot,
  AgentHoodSampleAgents: AgentHoodSampleAgents,
  AgenthoodCopytext: AgenthoodCopytext,
  AgentHoodFileUpload: AgentHoodFileUpload,
  AgentHoodMessageSend: AgentHoodMessageSend,
  AgentHoodSuccessIcon: AgentHoodSuccessIcon,
  AgentHoodFailedIconExclamation: AgentHoodFailedIconExclamation,
  Agentichood: Agentichood,
  RadioButtonChecked: radioButtonChecked,
  ChatbotIcon: ChatbotIcon,
  RemoveIcon: removeIcon,
};
